<template>
  <div class="count-flop" :key="compKey">
    <div :class="item != '.' && item != ',' ? 'count-flop-box' : 'count-flop-point'" v-for="(item, index) in value" :key="index">
      <div v-if="item == ','" class="count-flop-content">,</div>
      <div v-else-if="item == '.'" class="count-flop-content icon"></div>
      <div v-else class="count-flop-content" :class="['rolling_' + item]">
        <div v-for="(item2, index2) in numberList" :key="index2" class="count-flop-num">{{ item2 }}</div>
      </div>
    </div>
    <div v-if="suffix" class="count-flop-unit">{{ suffix }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: [],
      numberList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      compKey: 0,
    }
  },
  props: {
    val: {
        typeof: [Number, String],
        default: ''
    },
    suffix: {
        typeof: [Number, String],
        default: ''
    }
  },
  watch: {
    val() {
      this.value = this.val.toString().split('')
      this.compKey += 1
    },
  },
  created() {
    const value = this.formatNumber(this.val, 2, 1)
    this.value = value.toString().split('')
  },
  methods:{
    /**
     * formatNumber()
     * 将数值四舍五入后格式化.
     *
     * @param num 数值(Number或者String)
     * @param cent 要保留的小数位(Number)
     * @param isThousand 是否需要千分位 0:不需要, 1:需要(数值类型);
     * @return 格式的字符串,如'1,234,567.45'
     * @type String
     */
     formatNumber(num, cent, isThousand) {
      num = num.toString().replace(/$|,/g, '')
      if (isNaN(num)) num = '0'
      var sign = num == (num = Math.abs(num))
      num = parseFloat(num.toFixed(cent))
      num = num.toString()
      var cents
      if (num.lastIndexOf('.') != -1) {
        let index = num.lastIndexOf('.')
        cents = num.substring(index + 1, num.length)
      } else {
        cents = ''
      }
      num = Math.floor(num * Math.pow(10, cent) + 0.50000000001)
      num = Math.floor(num / Math.pow(10, cent)).toString()
      if (isThousand) {
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
      }
      if (cent > 0) {
        if (cents == '') {
          return (sign ? '' : '-') + num
        } else {
          return (sign ? '' : '-') + num + '.' + cents
        }
      } else {
        return (sign ? '' : '-') + num
      }
    },
  }
}
</script>
<style scoped>
.count-flop {
  display: inline-block;
  height: 50px;
  line-height: 50px;
  font-size: 30px;
  font-family: DIN, DIN;
  font-weight: 700;
  color: #efab44;
  user-select: none;
  display: flex;
  align-items: flex-end;
}

.count-flop > div {
  position: relative;
  display: inline-block;
  overflow: hidden;
  height: 100%;
  line-height: 45px !important;
}

.count-flop-box {
  margin-right: 6px;
  width: 35px;
  height: 45px !important;
  background: rgba(240, 210, 100, 0.1);
  box-shadow: inset 0px 0px 6px 0px rgba(240, 210, 100, 0.2);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid rgba(240, 210, 100, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.count-flop-point {
  margin-right: 5px;
  width: 10px;
}

.count-flop-content {
  text-align: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  animation-fill-mode: forwards !important;
}
.icon {
  width: 7px;
  height: 8px;
  font-size: 30px;
  font-family: DIN, DIN;
  font-weight: 700;
  color: #efab44;
  background: #efab44;
  top: 34px;
  border-radius: 1px;
}
.count-flop-unit {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(240, 210, 100, 0.1);
  box-shadow: inset 0px 0px 6px 0px rgba(240, 210, 100, 0.2);
  border-radius: 4px;
  text-align: center;
  font-size: 16px;
  align-items: center;
  letter-spacing: 0.1em;
  color: #ffffff;
}

.rolling_0 {
  animation: rolling_0 2.1s ease;
}

@keyframes rolling_0 {
  from {
    transform: translateY(-90%);
  }
  to {
    transform: translateY(0);
  }
}

.rolling_1 {
  animation: rolling_1 3s ease;
}

@keyframes rolling_1 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10%);
  }
}

.rolling_2 {
  animation: rolling_2 2.1s ease;
}

@keyframes rolling_2 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-20%);
  }
}

.rolling_3 {
  animation: rolling_3 3s ease;
}

@keyframes rolling_3 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-30%);
  }
}

.rolling_4 {
  animation: rolling_4 2.1s ease;
}

@keyframes rolling_4 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-40%);
  }
}

.rolling_5 {
  animation: rolling_5 3s ease;
}

@keyframes rolling_5 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-50%);
  }
}

.rolling_6 {
  animation: rolling_6 2.1s ease;
}

@keyframes rolling_6 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-60%);
  }
}

.rolling_7 {
  animation: rolling_7 3.1s ease;
}

@keyframes rolling_7 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-70%);
  }
}

.rolling_8 {
  animation: rolling_8 2.1s ease;
}

@keyframes rolling_8 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-80%);
  }
}

.rolling_9 {
  animation: rolling_9 3.6s ease;
}

@keyframes rolling_9 {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-90%);
  }
}
</style>
